import { Lock } from "lucide-react";

const inputCls = "w-full rounded-md border border-border bg-secondary/30 px-3 py-2 text-sm font-medium text-foreground outline-none focus:border-primary";

const splitMulti = (v) => String(v || "").split(";").map((x) => x.trim()).filter(Boolean);

function MultiSelect({ f, value, onChange }) {
  const sel = splitMulti(value);
  const toggle = (o) => onChange((sel.includes(o) ? sel.filter((x) => x !== o) : [...sel, o]).join("; "));
  return (
    <div className="flex flex-wrap gap-2" data-testid={`loi-field-${f.id}`}>
      {f.options.map((o) => {
        const on = sel.includes(o);
        return (
          <button key={o} type="button" onClick={() => toggle(o)} data-testid={`loi-opt-${f.id}-${o.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
            className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${on ? "border-primary bg-primary/15 text-primary" : "border-border text-muted-foreground hover:bg-secondary/50"}`}>
            {o}
          </button>
        );
      })}
    </div>
  );
}

export function LoiField({ f, value, onChange }) {
  let input;
  if (f.type === "multiselect") input = <MultiSelect f={f} value={value} onChange={onChange} />;
  else if (f.type === "select") input = (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`loi-field-${f.id}`} className={inputCls}>
      <option value="">—</option>
      {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
  else if (f.type === "textarea") input = (
    <textarea rows={3} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`loi-field-${f.id}`} className={inputCls} />
  );
  else input = <input value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`loi-field-${f.id}`} className={inputCls} />;
  return (
    <div className={`space-y-1.5 ${f.type === "multiselect" || f.type === "textarea" ? "sm:col-span-2" : ""}`}>
      <label className="flex items-center gap-1.5 text-[11px] uppercase tracking-wide text-muted-foreground font-medium">
        {f.label}
        {f.internal && <span className="inline-flex items-center gap-1 rounded bg-amber-500/15 px-1.5 py-0.5 text-[9px] text-amber-400 normal-case tracking-normal" data-testid={`loi-internal-${f.id}`}><Lock className="h-2.5 w-2.5" />ARQITEK only</span>}
      </label>
      {input}
    </div>
  );
}

export const applyToggles = (f, prev, next) => {
  if (!f.toggles) return {};
  const before = splitMulti(prev);
  const out = {};
  splitMulti(next).forEach((o) => { if (!before.includes(o) && f.toggles[o]) out[f.toggles[o]] = "Yes"; });
  return out;
};
